import produce from 'immer';
import * as types from './types';

const INITIAL_STATE = {
  token: null,
  signed: false,
  loading: false,
  errorAuth: null,
  institutionId: null,
  systemConfig: null,
};

export function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case types.SIGN_IN_REQUEST: {
        draft.loading = true;
        break;
      }
      case types.SIGN_IN_SUCCESS: {
        draft.token = action.payload.token;
        draft.cnes = action.payload.cnes;
        draft.roles = action.payload.roles;
        draft.institutionId = action.payload.institutionId;
        draft.systemConfig = action.payload.systemConfig;
        draft.signed = true;
        draft.loading = false;
        draft.errorAuth = false;
        break;
      }
      case types.SIGN_IN_FAILURE: {
        draft.loading = false;
        draft.errorAuth = true;
        break;
      }
      case types.SIGN_OUT: {
        draft.token = null;
        draft.signed = false;
        break;
      }
      case types.UPDATE_PROFILE_HOSP_REQUEST: {
        draft.systemConfig = {
          ...state.systemConfig,
          perfilInstituicaoPendente: false,
          dataUltimoPerfilInstituicao: action?.payload?.newDate,
        };
        break;
      }
      default:
        return state;
    }
  });
}
